import React, { ReactElement } from 'react'

import { useTheme } from '@emotion/react'

import { ArcadeIcon } from '@arcade/web/icons/react'

import { IconMat } from '../../IconMat/IconMat'
import { Flex } from '../../layout/Flex'
import Text from '../../Text/Text'

const getIcon = (Icon: ArcadeIcon) => (
  <IconMat>
    <Icon size={32} data-testid="page-header-icon" />
  </IconMat>
)

export interface ArcadePageHeaderAsset {
  Icon?: ArcadeIcon
  avatar?: ReactElement
}

export interface ArcadePageHeaderProps {
  title: string
  titleElement: React.ElementType
  body?: string
  asset?: ArcadePageHeaderAsset
}

const ArcadePageHeader = ({ title, titleElement, body, asset }: ArcadePageHeaderProps) => {
  const theme = useTheme()
  return (
    <Flex flexDirection="column" gap={theme.spacing.m}>
      {asset?.Icon ? getIcon(asset?.Icon) : asset?.avatar || null}
      <Text typography="header" color="textStandard" as={titleElement}>
        {title}
      </Text>
      {body && <Text typography="body">{body}</Text>}
    </Flex>
  )
}

export default ArcadePageHeader
